import React, { useRef, useState } from 'react';
import { StyleClass } from 'primereact/styleclass';
import { Ripple } from 'primereact/ripple';
import { Avatar } from 'primereact/avatar';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ClientLogo from '../assets/images/image.png';
import Logo2 from '../assets/images/barnksforte.png';
import { Outlet, Link, useLocation } from "react-router-dom";
import { logoutUser } from '../redux/functions';
import { useDispatch, useSelector } from 'react-redux';

const Home = () => {
    const btnRef22 = useRef(null);
    const [displayLogoutDialog, setDisplayLogoutDialog] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const { userInfo } = useSelector((state) => state.user);

    const logout = () => {
        logoutUser(dispatch);
        setDisplayLogoutDialog(false);
    };

    const navItems = [
        { label: 'Dashboard', icon: 'pi pi-home', to: '/' },
        { label: 'Devices', icon: 'pi pi-mobile', to: '/view-device' },
        { label: 'Activity Logs', icon: 'pi pi-list', to: '/activity-logs' },
    ];

    const isActive = (path) => location.pathname === path;

    const renderFooter = () => {
        return (
            <div className="flex justify-content-end gap-2">
                <Button label="Cancel" icon="pi pi-times" onClick={() => setDisplayLogoutDialog(false)} className="p-button-text p-button-secondary font-semibold" />
                <Button label="Sign Out" icon="pi pi-sign-out" onClick={logout} className="p-button-danger font-semibold px-4" autoFocus />
            </div>
        );
    };

    return (
        <div className="min-h-screen flex relative lg:static surface-ground">
            {/* Logout Confirmation Dialog */}
            <Dialog 
                header="Confirm Sign Out" 
                visible={displayLogoutDialog} 
                style={{ width: '350px' }} 
                footer={renderFooter()} 
                onHide={() => setDisplayLogoutDialog(false)}
                draggable={false}
                resizable={false}
                breakpoints={{'960px': '75vw', '641px': '90vw'}}
            >
                <div className="flex flex-column align-items-center justify-content-center pt-3">
                    <i className="pi pi-exclamation-triangle text-red-500 text-5xl mb-4"></i>
                    <p className="m-0 text-center text-700 font-medium line-height-3">Are you sure you want to log out of the Enterprise MDM console?</p>
                </div>
            </Dialog>

            {/* Sidebar */}
            <div id="app-sidebar-5" className="bg-green-900 h-screen hidden lg:block flex-shrink-0 sticky left-0 top-0 z-1 border-right-1 bg-green-600 w-18rem select-none shadow-4">
                <div className="flex flex-column h-full">
                    {/* Brand */}
                    <div className="flex align-items-center px-4 flex-shrink-0" style={{ height: '80px' }}>
                        <img src={ClientLogo} alt="Logo" height={50} className="mr-3" />
                        <span className="text-white font-bold text-xl tracking-tight"></span>
                    </div>

                    {/* Navigation */}
                    <div className="overflow-y-auto mt-3 flex-grow p-3">
                        <ul className="list-none p-0 m-0">
                            <li className="mb-2">
                                <span className="text-gray-500 font-bold text-xs uppercase p-3 block tracking-widest text-white-alpha-60">Main Menu</span>
                            </li>
                            {navItems.map((item, index) => (
                                <li key={index} className="mb-1">
                                    <Link 
                                        to={item.to} 
                                        className={`p-ripple flex align-items-center cursor-pointer p-3 border-round transition-duration-150 transition-colors w-full no-underline
                                            ${isActive(item.to) 
                                                ? 'bg-green-600 text-white shadow-2' 
                                                : 'text-white-alpha-70 hover:bg-green-800 hover:text-white'}`}
                                    >
                                        <i className={`${item.icon} mr-3 text-lg`}></i>
                                        <span className="font-medium">{item.label}</span>
                                        <Ripple />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* User Profile & Logout Section */}
                    <div className="mt-auto p-3 border-top-1 bg-green-700">
                        <div className="flex align-items-center p-3 bg-green-800 hover:bg-green-900 border-round transition-colors transition-duration-150 cursor-pointer mb-2">
                            <Avatar label={userInfo?.name?.charAt(0) || 'U'} shape="circle" className="mr-3 bg-white text-green-700 font-bold" />
                            <div className="flex flex-column overflow-hidden">
                                <span className="text-white font-bold text-sm block truncate">{userInfo?.name || 'Administrator'}</span>
                                <span className="text-white-alpha-60 text-xs truncate">Super Admin</span>
                            </div>
                        </div>
                        <button 
                            onClick={() => setDisplayLogoutDialog(true)}
                            className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-red-100 bg-red-700 hover:bg-red-900 hover:text-red-400 transition-colors transition-duration-150 w-full bg-transparent border-none text-left font-medium"
                        >
                            <i className="pi pi-sign-out mr-3 text-lg"></i>
                            <span>Sign Out</span>
                            <Ripple />
                        </button>
                        <div className="flex align-items-center justify-content-center mt-3 pt-3 border-top-1 border-green-800">
                            <img src={Logo2} alt="Barnksforte Logo" height={50} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="min-h-screen flex flex-column relative flex-auto w-full ">
                {/* Top Header */}
                <div className="flex justify-content-between align-items-center px-5 surface-section sticky top-0 z-2 border-bottom-1 surface-border" style={{ height: '60px' }}>
                    <div className="flex align-items-center">
                        <StyleClass nodeRef={btnRef22} selector="#app-sidebar-5" enterClassName="hidden" enterActiveClassName="fadeinleft" leaveToClassName="hidden" leaveActiveClassName="fadeoutleft" hideOnOutsideClick>
                            <button ref={btnRef22} className="p-ripple cursor-pointer block lg:hidden text-700 mr-3 bg-transparent border-none">
                                <i className="pi pi-bars text-3xl"></i>
                                <Ripple />
                            </button>
                        </StyleClass>
                        <img src={ClientLogo} alt="logo-mobile" height={50} className="lg:hidden mr-3" />
                        <div className="hidden lg:flex align-items-center gap-2">
                            <i className="pi pi-th-large text-gray-400"></i>
                            <span className="text-700 font-medium ml-2">Console</span>
                            <i className="pi pi-chevron-right text-300 text-sm ml-1"></i>
                            <span className="text-900 font-bold ml-1">
                                {navItems.find(item => isActive(item.to))?.label || 'Overview'}
                            </span>
                        </div>
                    </div>
                    
                    <div className="flex align-items-center gap-3 ">
                        <div className="hidden sm:flex align-items-center p-2 surface-100 border-round cursor-pointer hover:surface-200 transition-colors">
                            <i className="pi pi-bell text-600 mr-2 p-overlay-badge">
                                <span className="bg-red-500 border-circle block absolute" style={{ width: '8px', height: '8px', top: '2px', right: '2px' }}></span>
                            </i>
                            <span className="text-600 font-medium text-sm">Notifications</span>
                        </div>
                        <Avatar label={userInfo?.name?.charAt(0) || 'U'} shape="circle" className="bg-green-500 text-white lg:hidden" />
                    </div>
                </div>

                {/* Content Outlet */}
                <div className="p-4 lg:p-6 pb-8 overflow-y-auto">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Home;
